const toDateOrNull = (value) => {
  if (!value) return null;
  if (value.toDate) return value.toDate();
  if (value.seconds) return new Date(value.seconds * 1000);
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const toIsoOrNull = (value) => {
  const date = toDateOrNull(value);
  return date ? date.toISOString() : null;
};

/**
 * Verordnungs-Snapshot für eine Krankenfahrt.
 *
 * Die Abrechnung liest ausschließlich diesen Snapshot, nicht die Verordnung —
 * deshalb müssen Kassen-/Arztkennungen und die Patientenanschrift zwingend
 * mitkopiert werden. Fehlten sie hier, käme jede neu angelegte Fahrt ohne
 * Kassendaten in den Export; nachgezogen würde erst der Re-Sync bei der
 * nächsten Verordnungsänderung.
 *
 * Wird von RideForm (Einzelfahrt) und RecurringOrderEditForm (Serie) genutzt,
 * damit beide Wege identische Snapshot-Daten schreiben.
 */
export const buildMedicalTransportSnapshot = (order) => {
  if (!order) return null;
  return {
    id: order.id,
    patientName: order.patientName || '',
    patientBirthDate: toIsoOrNull(order.patientBirthDate),
    patientPhone: order.patientPhone || '',
    healthInsuranceName: order.healthInsuranceName || '',
    healthInsuranceIk: order.healthInsuranceIk || '',
    insuranceNumber: order.insuranceNumber || '',
    insuranceStatus: order.insuranceStatus || '',
    practiceNumber: order.practiceNumber || '',
    physicianNumber: order.physicianNumber || '',
    patientStreet: order.patientStreet || '',
    patientHouseNumber: order.patientHouseNumber || '',
    patientZip: order.patientZip || '',
    patientCity: order.patientCity || '',
    patientAddressAddition: order.patientAddressAddition || '',
    patientCountry: order.patientCountry || 'DE',
    prescriptionNumber: order.prescriptionNumber || '',
    prescriptionDate: toIsoOrNull(order.prescriptionDate),
    prescriptionMarkBvg: order.prescriptionMarkBvg === true,
    prescriptionMarkAccident: order.prescriptionMarkAccident === true,
    prescriptionMarkWorkAccident: order.prescriptionMarkWorkAccident === true,
    prescriptionMarkOther: order.prescriptionMarkOther === true,
    approvalNumber: order.approvalNumber || '',
    approvalKind: order.approvalKind || '',
    approvalRequired: order.approvalRequired !== false,
    approvalStatus: order.approvalStatus || 'missing',
    approvalApprovedAt: toIsoOrNull(order.approvalApprovedAt),
    approvalValidUntil: toIsoOrNull(order.approvalValidUntil),
    copaymentStatus: order.copaymentStatus || 'unknown',
    copaymentDocumentMode: (order.copaymentDocumentMode || '0').toString(),
    validFrom: toIsoOrNull(order.validFrom),
    validUntil: toIsoOrNull(order.validUntil),
    maxRides: Number(order.maxRides) || 0,
    ridesPerWeek: Number(order.ridesPerWeek) || 0,
    usedRides: Number(order.usedRides) || 0,
    plannedRides: Number(order.plannedRides) || 0,
    routeScope: order.routeScope || 'fixed_route',
    treatmentType: order.treatmentType || 'other',
    pickupAddress: order.pickupAddress || '',
    destinationAddress: order.destinationAddress || '',
    defaultVehicleType: Number(order.defaultVehicleType) || 1,
    requiredCapabilities: Array.isArray(order.requiredCapabilities) ? order.requiredCapabilities : [],
    documentStatus: order.documentStatus || 'incomplete',
    billingStatus: order.billingStatus || 'not_ready'
  };
};

export default buildMedicalTransportSnapshot;
